import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { PDF, View } from '../../../../components/Icon';
import { List, Row, Cell as TCell } from '../../../../components/List';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { formatLicensePlate } from '../../../../utils/string';
import { selectWorks } from '../../../Api/selectors';
import { kanbanMock, performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from './../BaseCellComp';
import { Cell } from '../Cell';
import { CellButton, CellButtons } from './../CellButton';

import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { SetBVIDone } from './SetBVIDone';
import styles from './BVI.module.css';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const Container = styled.div``;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BVIRequestVehicleTransferComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve) return null;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.BVIRequestVehicleTransfer.modal.title')}>
        <div className="d-flex gap-2 flex-wrap">
        <SetBVIDone className={styles.confirmButton} vehicle={this.vehicle} onComplete={this.reset.bind(this)} />
          <ButtonComponent
            style={'ButtonSoftEdit'}
            
            onClick={() => {
              this.reset();
              this.confirm();
            }}
          >
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>{this.lbl('cancel')}</ButtonComponent>
          
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
{/* 
                <CellButton onClick={() => this.toHelgaVehicle(vehicle.vehicle_helga_id)}>
                  <img height="23" src="/public/helga_icon.svg" />
                </CellButton> */}
              </div>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

BVIRequestVehicleTransferComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId + '_' + ownProps.cell.vehicle.id]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id) {
      dispatch(performAction(ownProps.action.id, vehicle_id));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BVIRequestVehicleTransfer = compose(
  withConnect,
  withRouter,
)(BVIRequestVehicleTransferComp);
